export enum ShowroomApplicationState {
    VALID = 'VALID',
    INVALID = 'INVALID',
    MISSING_VEHICLE = 'MISSING_VEHICLE',
    IN_PROGRESS = 'IN_PROGRESS',
    SENT_FOR_DESKING = 'SENT_FOR_DESKING',
    DESKED = 'DESKED',
    ACCEPTED = 'ACCEPTED'
}
